import {Box, Button, type ButtonProps, type SxProps, type Theme} from '@mui/material';
import {COLORS} from '~/style/colors-ts';

export type SegmentedControlProps = {
    /** Button labels in display order. */
    labels: string[];
    /** Index of the currently selected button. */
    value: number;
    onChange: (index: number) => void;
    disabled?: boolean;
    className?: string;
    sx?: SxProps<Theme>;
    buttonProps?: ButtonProps;
};

const rootSx: SxProps<Theme> = {
    display: 'flex',
    borderRadius: '8px',
    backgroundColor: 'rgba(226, 226, 233, 1)',
    p: '2px',
    gap: '4px',
};

const getButtonSx = (selected: boolean): SxProps<Theme> => ({
    flex: 1,
    minWidth: 0,
    fontSize: '12px',
    color: COLORS.text.primary,
    ...(selected
        ? {
            background: COLORS.white[900],
        }
        : {
            background: 'transparent',
        }),
});

export function SegmentedControl({
                                     labels,
                                     value,
                                     onChange,
                                     disabled = false,
                                     className,
                                     buttonProps,
                                     sx,
                                 }: SegmentedControlProps) {
    return (
        <Box className={className} sx={[rootSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
            {labels.map((label, index) => (
                <Button
                    key={`${label}-${index}`}
                    size="small"
                    color="inherit"
                    disabled={disabled}
                    onClick={() => onChange(index)}
                    sx={getButtonSx(index === value)}
                    {...buttonProps}
                >
                    {label}
                </Button>
            ))}
        </Box>
    );
}
